import { getCanonicalStageId } from "../../services/kanban";

export const emptyFilters = { searchParam: "", dateStart: "", dateEnd: "", status: "", stageId: "", onlyMine: false, unread: false };
export const emptyBoard = () => ({ tickets: [], count: 0, laneCounts: { none: 0 }, hasMore: false, nextCursor: null });

export function moveInBoard(board, command) {
  const ticket = board.tickets.find(item => Number(item.id) === command.ticketId);
  if (!ticket) return board;
  const fromId = getCanonicalStageId(ticket);
  const toId = command.stage ? Number(command.stage.id) : null;
  const updated = {
    ...ticket,
    tags: [...(ticket.tags || []).filter(tag => Number(tag.kanban) !== 1), ...(command.stage ? [{ ...command.stage, kanban: 1 }] : [])],
    kanbanVersion: command.version === undefined ? ticket.kanbanVersion : command.version,
    kanbanEnteredAt: command.enteredAt || ticket.kanbanEnteredAt,
  };
  const counts = { ...board.laneCounts };
  if (fromId !== toId) {
    counts[fromId || "none"] = Math.max(0, (Number(counts[fromId || "none"]) || 0) - 1);
    counts[toId || "none"] = (Number(counts[toId || "none"]) || 0) + 1;
  }
  return { ...board, laneCounts: counts, tickets: board.tickets.map(item => Number(item.id) === command.ticketId ? updated : item) };
}

export function confirmMove(board, command, filters) {
  const result = moveInBoard(board, command);
  const target = command.stage ? String(command.stage.id) : "none";
  if (!filters.stageId || String(filters.stageId) === target || !result.tickets.some(item => Number(item.id) === command.ticketId)) return result;
  return {
    ...result,
    tickets: result.tickets.filter(item => Number(item.id) !== command.ticketId),
    count: Math.max(0, result.count - 1),
    laneCounts: { ...result.laneCounts, [target]: 0 },
  };
}

export function stageAge(value, now = Date.now()) {
  const date = value ? new Date(value).getTime() : NaN;
  if (!Number.isFinite(date)) return "";
  const minutes = Math.max(0, Math.floor((now - date) / 60000));
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  return `${Math.floor(hours / 24)} d`;
}
